export default class StructureDetailsService {
  constructor (Api) {
    this.api = Api;
  }

  getDetails (structureId) {
    return this.api.get(`configs/structures/${structureId}`);
  }
}
